module.exports = __webpack_public_path__ + "img/10_b2b_rainmaker.2feb7178.png";